import { gql, useMutation } from '@apollo/client';
import React, { useState } from 'react';
import { MenuComponent } from 'src/components/MenuComponent';

const UPLOAD = gql`
  mutation upload($file: Upload!) {
    upload(file: $file) {
      filename
      url
    }
  }
`;

export function Thumbnail({ state, setState }: { state: any; setState: any }){
  let refUpload: HTMLInputElement;
  const [uploadOn, setUploadOn] = useState<"banner" | "profile">("banner");

  const [upload] = useMutation(UPLOAD, {
    onCompleted: (res) => {
      if (uploadOn === "banner") {
        setState({
          ...state,
          banner: res.upload.url,
        });
      } else {
        setState({
          ...state,
          logo: res.upload.url,
        });
      }
    },
  });

  const onChangeUpload = (e: any) => {
    upload({
      variables: {
        file: e.target.files[0],
      },
    });
  };

  return (
    <div
      className="up-head-w"
      style={{ backgroundImage: `url(https:${state.banner})` }}
    >
      <input
        type="file"
        value=""
        ref={(ref) => (refUpload = ref!)}
        onChange={onChangeUpload}
        style={{ display: "none" }}
      />
      <div className="up-social">
        <MenuComponent
          items={[
            {
              label: "Upload Banner",
              actived: true,
              onClick: () => {
                setUploadOn("banner");
                refUpload.click();
              },
            },
            {
              label: "Upload Profile",
              actived: true,
              onClick: () => {
                setUploadOn("profile");
                refUpload.click();
              },
            },
          ]}
          menuButton={
            <span style={{ cursor: "pointer", fontSize: 20 }}>
              <i className="os-icon os-icon-edit"></i>
            </span>
          }
        />
      </div>
      <div className="up-main-info">
        <div style={{ display: "flex" }}>
          <div className="user-avatar-w" style={{ marginRight: 10 }}>
            <div className="user-avatar" style={{ position: "relative" }}>
              <img src={"https:" + state.logo} alt="" />
            </div>
          </div>
          <div>
            <h2 className="up-header" style={{ textTransform: "capitalize" }}>
              {state.name}
            </h2>
            <h6 className="up-sub-header">{state.registerNumber!}</h6>
          </div>
        </div>
      </div>
    </div>
  );
}